const store = {
    state: {},
    mutations: {},
    actions: {},
    getters: {}
};

export default store;
